<div class="backdrop-blur-sm border-b border-border-solid px-12 py-6 max-sm:px-4 max-sm:py-3">
  <div class="flex items-center justify-between max-lg:flex-col max-lg:items-stretch max-lg:gap-3">
    <div class="flex items-center gap-8">
      <!-- Actuar Logo -->
      <div class="pr-4 flex items-end flex-col justify-end gap-1 max-lg:pr-0 max-lg:items-start">
        <lib-system-icons
          [iconFill]="'[&_path]:fill-black dark:[&_path]:fill-white'"
          [iconName]="'logo-ediz-text'"
          [iconHeight]="40"
        ></lib-system-icons>
        <p class="text-foreground-50 content-regular !text-[18px] w-fit max-sm:!text-[14px]">Live Pickup</p>
      </div>
    </div>

    <div class="flex items-center gap-8 max-lg:w-full max-lg:gap-3 max-lg:justify-between">
      <div class="relative flex items-center w-[283px]">
        <button
          #gateAnchor
          type="button"
          class="flex items-center gap-4 rounded-md max-sm:gap-2 w-full"
        >
          <div class="grid h-12 w-12 shrink-0 place-items-center rounded-md text-foreground-50 max-sm:h-9 max-sm:w-9">
            <i class="fi fi-rr-marker text-2xl leading-[0] max-sm:text-base"></i>
          </div>
          <div class="text-left flex-1 min-w-0">
            <p class="text-foreground-50 content-regular !text-[18px] max-sm:!text-xs">{{ 'ACCESS.CHECKIN.LIVE_PICKUP.GATE' | translate }}</p>
            <p class="flex items-center gap-[15px] text-xl font-semibold text-foreground max-sm:text-sm truncate">
              <span class="min-w-0 flex-1 truncate">{{ portao() || ('ACCESS.CHECKIN.LIVE_PICKUP.GATE_ALL' | translate) }}</span>
              @if (selectedGateOption().value) {
                <lib-signal-quality-icon class="shrink-0" [quality]="selectedGateOption().value.signalQuality" />
              }
              <i class="fi fi-rr-angle-small-down text-lg leading-[0] text-foreground-50 max-sm:text-base"></i>
            </p>
          </div>
        </button>
        <lib-dropdown-list
          [anchor]="gateAnchor"
          [dataSource]="gateOptions()"
          [selectedOption]="selectedGateOption()"
          [itemTemplate]="gateItemTemplate"
          (selectionChange)="onGateSelected($event)"
        />
        <ng-template #gateItemTemplate let-item>
          <div class="flex items-center justify-between gap-4 px-4 py-2.5">
            <span class="content-regular truncate text-foreground">{{ item.description | translate }}</span>
            @if (item.value) {
              <lib-signal-quality-icon class="shrink-0" [quality]="item.value.signalQuality" />
            }
          </div>
        </ng-template>
      </div>
      <div class="flex items-center gap-4sim max-sm:gap-2">
        <div class="grid h-12 w-12 shrink-0 place-items-center rounded-md text-foreground-50 max-sm:h-9 max-sm:w-9">
          <i class="fi fi-rr-users text-2xl leading-[0] max-sm:text-base"></i>
        </div>
        <div>
          <p class="text-foreground-50 content-regular !text-[18px] max-sm:!text-xs">{{ 'ACCESS.CHECKIN.LIVE_PICKUP.WAITING_ENTRY' | translate }}</p>
          <p class="text-xl font-semibold text-foreground max-sm:text-sm">{{ waitingInQueue() }} {{ 'ACCESS.CHECKIN.LIVE_PICKUP.PEOPLE' | translate }}</p>
        </div>
      </div>
      <!-- Current Time -->
      <div class="flex items-center gap-4 max-sm:w-auto max-sm:gap-2">
        <div class="grid h-12 w-12 shrink-0 place-items-center rounded-md text-foreground-50 max-sm:h-9 max-sm:w-9">
          <i class="fi fi-rr-clock text-2xl leading-[0] max-sm:text-base"></i>
        </div>
        <div>
          <p class="text-4xl font-semibold text-foreground tabular-nums max-sm:text-lg">{{ currentTime() | intlDateTime: { hour: '2-digit', minute: '2-digit', second: '2-digit' } }}</p>
        </div>
      </div>
      <lib-live-pickup-theme-switcher />
    </div>
  </div>
</div>
